export default __webpack_public_path__ + "static/media/sv.f4c18695.svg";